import { createSelector } from 'reselect';

// Sélecteur pour obtenir les positions depuis le store
const selectEvents = state => state.events?.initialData?.events || [];

// Sélecteur pour compter les alertes (URGENCY_LEVEL 3)
export const selectEventsAlertCount = createSelector(
    [selectEvents],
    (events) => events.filter(feature => feature.URGENCY_LEVEL === "3").length
);

// Sélecteur pour compter les stops (URGENCY_LEVEL 4)
export const selectEventsStopCount = createSelector(
    [selectEvents],
    (events) => events.filter(feature => feature.URGENCY_LEVEL === "4").length
);

// Sélecteur pour compter les pré alertes (URGENCY_LEVEL 0)
export const selectEventsPreAlertCount = createSelector(
    [selectEvents],
    (events) => events.filter(feature => feature.URGENCY_LEVEL === "0").length
);

// Sélecteur pour compter le total d'événements
export const selectEventsTotalCount = createSelector(
    [selectEvents],
    (events) => events.length
);